export const Notification = {
    success(msg = "Successfully Done") {
        new Noty({
            type: "success",
            layout: "topRight",
            text: msg,
            timeout: 3000,
            closeWith: ['button'],
        }).show();
    },
    successPlaceOrder(msg) {
        new Noty({
            type: "success",
            layout: "topRight",
            text: msg,
            timeout: 3000,
            closeWith: ['button'],
        }).show();
    },
    alert() {
        new Noty({
            type: "alert",
            layout: "topRight",
            text: "Are you sure?",
            timeout: 3000,
            closeWith: ['button'],
        }).show();
    },

    error() {
        new Noty({
            type: "error",
            layout: "topRight",
            text: "Something went wrong!",
            timeout: 3000,
            closeWith: ['button'],
        }).show();
    },
    customeTextError(msg) {
        new Noty({
            type: "error",
            layout: "topRight",
            text: msg,
            timeout: 10000,
            closeWith: ['button'],
        }).show();
    },
    warning() {
        new Noty({
            type: "warning",
            layout: "topRight",
            text: "Opps wrong something",
            timeout: 10000,
            closeWith: ['button'],
        }).show();
    },

    image_validation() {
        new Noty({
            type: "error",
            layout: "topRight",
            text: "Upload image should less than 1MB",
            timeout: 3000,
            closeWith: ['button'],
        }).show();
    },

    loginSuccess() {
        new Noty({
            type: "success",
            layout: "topRight",
            text: 'logged in successfully',
            timeout: 3000,
            closeWith: ['button'],
        }).show();
    },
    loginError() {
        new Noty({
            type: "warning",
            layout: "topRight",
            text: "Invalid Email or Password",
            timeout: 10000,
            closeWith: ['button'],
        }).show();
    },
    logout() {
        new Noty({
            type: "success",
            layout: "topRight",
            text: "Logout successfully",
            timeout: 3000,
            closeWith: ['button'],
        }).show();
    },
    existEmail(error) {
        new Noty({
            type: "error",
            layout: "topRight",
            text: error,
            timeout: 10000,
            closeWith: ['button'],
        }).show();
    },
    tableErr(msg) {
        new Noty({
            type: "error",
            layout: "topRight",
            text: msg,
            timeout: 10000,
            closeWith: ['button'],
        }).show();
    }

}